import { cn } from '~/lib/cn';

export interface CardProps {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}

function Card({ className, children }: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        'rounded-sm border p-lg bg-level-02 border-emphasis-subtle',
        className,
      )}
      data-testid="card"
    >
      <div className="flex h-full min-h-[7.2em] flex-col">{children}</div>
    </div>
  );
}

Card.displayName = 'Card';

export { Card };
